import { BrandMark } from "./BrandMark";

export function SceneLoading() {
  return (
    <main className="scene-loading" aria-live="polite" aria-label="正在进入记忆星河">
      <BrandMark compact />
      <span className="scene-loading__line" />
    </main>
  );
}

